export function formatValue(num: number, decimals: number): string {
    return new Intl.NumberFormat('no-NB', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
}